module.exports = __webpack_public_path__ + "img/ajxq_01.48db7942.jpg";